import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.string.repeat.js";
import { BaseTransformer } from './BaseTransformer';
export var PreferencesTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(PreferencesTransformer, _BaseTransformer);
  var _super = _createSuper(PreferencesTransformer);
  function PreferencesTransformer() {
    _classCallCheck(this, PreferencesTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(PreferencesTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      if (!data.decimal_precision) {
        data.decimal_precision = 2;
      }
      if (!data.thousand_separator) {
        data.thousand_separator = '.';
      }
      if (!data.decimal_separator) {
        data.decimal_separator = ',';
      }
      var text = '0';
      var NumDecimal = text.repeat(data.decimal_precision);
      var numberFormat = '0' + data.thousand_separator + '000' + data.decimal_separator + '' + NumDecimal;
      return {
        baseCurrency: data.base_currency,
        currencyFormat: data.currency_abbr_position,
        // defaultCapacity: data.default_capacity,
        // defaultDailyWorkingHours: data.default_daily_working_hours,
        fiscalYear: data.fiscal_year,
        longDateFormat: data.long_date_format,
        locale: data.locale_id,
        language: data.language_id,
        shortDateFormat: data.date_format,
        startWeekOn: data.start_week_on,
        // success: data.success,
        timeFormat: data.time_format,
        timeRounding: data.time_rounding,
        timeZone: data.time_zone_id,
        workingHoursStartTime: data.business_hours_begin,
        workingHourEndTime: data.business_hours_end,
        numberFormat: numberFormat,
        decimalSeparator: data.decimal_separator,
        thousandSeparator: data.thousand_separator,
        decimalprecision: data.decimal_precision,
        defaultCapacity: data.weekly_working_capacity,
        system: data.system,
        defaultDailyWorkingHours: data.daily_working_hours
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      var numberFormat = data.numberFormat;
      var decimal_separator = ",";
      var thousand_separator = ".";
      var decimal_precision = 2;
      if (numberFormat && numberFormat.length == 8) {
        thousand_separator = numberFormat.charAt(1);
        decimal_separator = numberFormat.charAt(5);
        decimal_precision = numberFormat.substring(6).length;
      }
      return {
        base_currency: data.baseCurrency,
        currency_abbr_position: data.currencyFormat,
        weekly_working_capacity: data.defaultCapacity,
        system: data.system,
        daily_working_hours: data.defaultDailyWorkingHours,
        fiscal_year: data.fiscalYear,
        long_date_format: data.longDateFormat,
        locale_id: data.locale,
        date_format: data.shortDateFormat,
        start_week_on: data.startWeekOn,
        time_format: data.timeFormat,
        time_rounding: data.timeRounding,
        time_zone_id: data.timeZone,
        language_id: data.language,
        decimal_separator: decimal_separator,
        thousand_separator: thousand_separator,
        decimal_precision: decimal_precision,
        business_hours_end: data.workingHourEndTime,
        business_hours_begin: data.workingHoursStartTime
      };
    }
  }]);
  return PreferencesTransformer;
}(BaseTransformer);